import React from "react";
import "./FilterBar.css";

const mainCategories = ["Saç Bakımı", "Cilt Bakımı", "Vücut Bakımı"];

const subCategoryMappings = {
  "Saç Bakımı": {
    "Şampuan": ["Shampoo", "Men Shampoo"],
    "Saç Kremi": ["Hair Condititioner"],
    "Saç Maskesi": ["Hair Mask"],
    "Saç Serumu": ["Hair Serum"],
    "Saç Yağı": ["Hair Oil"],
    "Saç Bakımı": ["Hair Care", "Men Hair Care"],
    "Saç Şekillendirme": ["Hair Styling"],
    "Saç Boyası": ["Hair Color", "Hair Color Opener"],
  },
  "Cilt Bakımı": {
    "Yüz Temizleyici": ["Yüz Temizleyici"],
    "Yüz Kremi": ["Yüz Kremi"],
    "Tonik": ["Tonik"],
    "Serum ve Bakım Yağları": ["Serum ve Bakım Yağları"],
    "Peeling": ["Peeling"],
    "Maske": ["Maske"],
    "Göz Çevresi Bakımı": ["Göz Çevresi Bakımı"]
  },
  "Vücut Bakımı": {
    "Vücut Bakımı": ["Vücut Bakımı"],
    "Kaş Kirpik Bakımı": ["Kaş Kirpik Bakımı"],
    "Dudak Bakımı": ["Dudak Bakımı"],
  },
  "Güneş Koruyucu": { "Güneş Koruyucu": ["Güneş Koruyucu"] },
  "Makyaj": {
    "Fondöten": ["Fondöten"]
  },
  "Takviye Gıda/Vitamin": { 
    "Vitamin ve Sağlık": [] 
  },
  "Yiyecek/İçecek": { 
    "Yiyecek/İçecek": [] 
  }
};

const goodForMappings = {
  "Saç Bakımı": ["Kuru Saç", "Yağlı Saç", "Kepek", "Hassas Deri", "Dökülme Karşıtı"],
  "Cilt Bakımı": ["Kuru Cilt", "Yağlı Cilt", "Sivilceye Eğilimli", "Hassas Cilt"],
  "Vücut Bakımı": ["Kuru Vücut", "Yağlı Vücut", "Egzama", "Hassas Vücut"],
};

const preferenceMappings = {
  "Sülfat İçermez": "sulfate_free",
  "Paraben İçermez": "paraben_free",
  "Tuz İçermez": "salt_free",
  "Silikon İçermez": "silicone_free",
  "Parfüm İçermez": "fragrance_free",
  "Alkol İçermez": "alcohol_free",
};

const preferences = Object.keys(preferenceMappings);
const ingredients = ["Keratin", "Biotin", "Aloe Vera", "Hindistan Cevizi Yağı", "E Vitamini", "Argan Yağı"];

const FilterBar = ({ isOpen, setIsOpen, selectedFilters, setSelectedFilters }) => {
  if (!isOpen) return null;

  const handleMultiSelect = (filterKey, value) => {
    setSelectedFilters((prev) => {
      const current = prev[filterKey] || [];
      const updated = current.includes(value)
        ? current.filter((item) => item !== value)
        : [...current, value];
      return { ...prev, [filterKey]: updated };
    });
  };

  const handleMainCategorySelect = (category) => {
    setSelectedFilters((prev) => ({
      ...prev,
      mainCategory: category,
      subCategory: [],
      goodFor: [],
    }));
  };

  const handleSubCategorySelect = (subCat) => {
    handleMultiSelect("subCategory", subCat);
  };

  return (
    <>
      <div className="filter-overlay" onClick={() => setIsOpen(false)} />
      <div className="filter-modal">
        <div className="filter-header">
          <div className="filter-title">Filtreler</div>
          <button className="close-filter" onClick={() => setIsOpen(false)}>
            ✕
          </button>
        </div>

        <div className="filter-section">
          <h4>Ana Kategori</h4>
          <div className="filter-options">
            {mainCategories.map((item) => (
              <button
                key={item}
                className={`filter-pill ${selectedFilters.mainCategory === item ? "active" : ""}`}
                onClick={() => handleMainCategorySelect(item)}
              >
                {item}
              </button>
            ))}
          </div>
        </div>

        {selectedFilters.mainCategory && (
          <div className="filter-section">
            <h4>Alt Kategori</h4>
            <div className="filter-options">
              {Object.keys(subCategoryMappings[selectedFilters.mainCategory]).map((subCat) => (
                <button
                  key={subCat}
                  className={`filter-pill ${selectedFilters.subCategory && selectedFilters.subCategory.includes(subCat)
                    ? "active"
                    : ""
                    }`}
                  onClick={() => handleSubCategorySelect(subCat)}
                >
                  {subCat}
                </button>
              ))}
            </div>
          </div>
        )}

        <div className="filter-section">
          <h4>Tercihler</h4>
          <div className="filter-options">
            {preferences.map((item) => (
              <button
                key={item}
                className={`filter-pill ${selectedFilters.preferences && selectedFilters.preferences.includes(item) ? "active" : ""
                  }`}
                onClick={() => handleMultiSelect("preferences", item)}
              >
                {item}
              </button>
            ))}
          </div>
        </div>

        <div className="filter-section">
          <h4>İçerikler</h4>
          <div className="filter-options">
            {ingredients.map((item) => (
              <button
                key={item}
                className={`filter-pill ${selectedFilters.ingredients && selectedFilters.ingredients.includes(item) ? "active" : ""
                  }`}
                onClick={() => handleMultiSelect("ingredients", item)}
              >
                {item}
              </button>
            ))}
          </div>
        </div>

        {selectedFilters.mainCategory && (
          <div className="filter-section">
            <h4>Şuna İyi Gelir</h4>
            <div className="filter-checkboxes">
              {goodForMappings[selectedFilters.mainCategory].map((gf) => (
                <label key={gf} className="checkbox-container">
                  <input
                    type="checkbox"
                    checked={selectedFilters.goodFor && selectedFilters.goodFor.includes(gf)}
                    onChange={() => handleMultiSelect("goodFor", gf)}
                  />
                  <span className="checkmark"></span>
                  {gf}
                </label>
              ))}
            </div>
          </div>
        )}

        <button className="filter-open-btn" onClick={() => setIsOpen(false)}>
          Uygula
        </button>
      </div>
    </>
  );
};

export default FilterBar;
export { mainCategories, subCategoryMappings, goodForMappings, preferenceMappings };
